module.exports = "https://static.wanderu.com/ui-react/_next/static/media/fr.c88df329.svg";